import Vue from 'vue'
import Router from 'vue-router'
import bus from './bus'

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    name: 'home',
    component: () => import('./views/home'),
    meta: {
      title: '首页',
      showBar:true,
    }
  },
  {
    name: 'classification',
    component: () => import('./views/classification'),
    meta: {
      title: '分类',
      showBar:true,
    }
  },
  {
    name: 'carts',
    component: () => import('./views/carts'),
    meta: {
      title: '购物车',
      showBar:true,
    }
  },
  {
    name: 'user',
    component: () => import('./views/user'),
    meta: {
      title: '会员中心',
      showBar:true,
    }
  },
  {
    name: 'goods/:id',
    component: () => import('./views/goods'),
    meta: {
      title: '商品详情'
    },
    props: true
  },
  {
    name: 'search',
    component: () => import('./views/search'),
    meta: {
      title: '搜索'
    }
  },
  {
    name: 'order-list',
    component: () => import('./views/order-list'),
    meta: {
      title: '我的订单'
    }
  },
  {
    name: 'order-submit',
    component: () => import('./views/order-submit'),
    meta: {
      title: '确认订单'
    }
  },
  {
    name: 'order-details',
    component: () => import('./views/order-details'),
    meta: {
      title: '订单详情'
    }
  },
  {
    name: 'address',
    component: () => import('./views/address'),
    meta: {
      title: '收货地址'
    }
  },
  {
    name: 'direct-purchase',
    component: () => import('./views/direct-purchase'),
    meta: {
      title: '分货直购'
    }
  },
  {
    name: 'address-edit',
    component: () => import('./views/address/edit'),
    meta: {
      title: '地址编辑'
    }
  },
  {
    name: 'linshi',
    component: () => import('./views/address/linshi'),
    meta: {
      title: '新增临时地址'
    }
  },
  {
    name: 'pay',
    component: () => import('./views/pay'),
    meta: {
      title: '支付'
    }
  },
  {
    name: 'login',
    component: () => import('./views/login'),
    meta: {
      title: '欢迎登录'
    }
  },
  {
    name: 'logout',
    meta: {
      title: '退出登录'
    }
  },
  {
    name: 'balance',
    component: () => import('./views/balance'),
    meta: {
      title: '余额'
    }
  },
  {
    name: 'bills',
    component: () => import('./views/bills'),
    meta: {
      title: '账单'
    }
  },
  {
    name: 'bank-card-pay',
    component: () => import('./views/bank-card-pay'),
    meta: {
      title: '银行卡支付'
    }
  },
  {
    name: 'ql-bank-card/binding',
    component: () => import('./views/ql-bank-card/binding'),
    meta: {
      title: '银行卡绑定'
    }
  },
  {
    name: 'ql-bank-card',
    component: () => import('./views/ql-bank-card'),
    meta: {
       title: '我的银行卡'
    }
  },
  {
    name: 'collection_banking',
    component: () => import('./views/ql-bank-card/collection_banking'),
    meta: {
      title: '商家收款账号'
    }
  },
  {
    name: 'register',
    component: () => import('./views/login/register'),
    meta: {
       title: '注册新客户'
    }
  },
  {
    name: 'logistics',
    component: () => import('./views/logistics'),
    meta: {
      title: '物流信息'
    }
  },
  {
    name: 'weidian',
    component: () => import('./views/user-bind'),
    meta: {
      title: '一健开店',
    }
  },
  {
    name: 'tip',
    component: () => import('./views/user-bind/tip'),
    meta: {
      title: '提示',
    }
  },
  {
    name: 'user-bind',
    component: () => import('./views/user-bind/bind'),
    meta: {
      title: '用户绑定/解绑',
    }
  },
  {
    name: 'bind-tip',
    component: () => import('./views/user-bind/bind-tip'),
    meta: {
      title: '提示',
    }
  },
  {
    name: 'notices',
    component: () => import('./views/notices/index'),
    meta: {
      title: '消息通知',
    }
  },
  {
    name: 'invoice',
    component: () => import('./views/invoice/index'),
    meta: {
      title: '发票',
    }
  },
  {
    name: 'invoice-details',
    component: () => import('./views/invoice/detailsList'),
    meta: {
      title: '发票',
    }
  },
  {
    name: 'cash-back',
    component: () => import('./views/cash-back/index'),
    meta: {
      title: '返利价保',
    }
  },
  {
    name: 'cash-back-details',
    component: () => import('./views/cash-back/detailsList'),
    meta: {
      title: '返利价保',
    }
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({routes});

router.beforeEach((to, from, next) => {
  if (to.path.includes('logout')) {
    bus.state.token = undefined;
    next('/login');
  }
  changeTabBarActive(to.path.replace("/", ""));
  bus.state.showBar=to.meta.showBar
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

function changeTabBarActive(inPath) {
  const pathArray = ['home', 'classification', 'direct-purchase','carts', 'user'];
  const getIndex = (path) => {
    for (let index in pathArray) {
      if (pathArray[index] === path) {
        return index;
      }
    }
    return -1;
  };
  let index = getIndex(inPath);
  if (index > -1) {
    bus.state.tabBarActive = index;
  }
}

export default router
